<template>
    <div
        class="block-modal"
        v-animate-css="{ classes: 'slideInRight', delay: 0, duration: 500 }"
        :block-type="block.type"
    >
        <div class="main">
            <div class="header">
                <div class="left">
                    <div class="d-flex align-items-center align-content-center justify-content-start pb-2">
                        <BlockIconPreview class="mr-2" style="color: #919ead" :block-type="block.type" />
                        <span class="blockTypeText">{{ $t(`chatbotv2.${block.type}`) }}</span>
                    </div>
                    <div class="name">
                        <BlockTitle
                            :name="block.name"
                            :storyId="storyId"
                            :block="block"
                            :storyVersion="storyVersion"
                            :is-save="isSaveProp"
                        />
                    </div>
                </div>
                <div class="right">
                    <button class="chatbot-btn" @click="$emit('close')">
                        <md-icon style="color: red">close</md-icon>
                    </button>
                    <button class="chatbot-btn" @click="updatePayload()" v-if="!previewMode">
                        <md-icon style="color: green">save</md-icon>
                    </button>
                    <button
                        v-if="
                            !block.type.includes('PROBEL') &&
                            !block.type.includes('IDEASOFT') &&
                            !block.type.includes('B2CARGO') &&
                            !block.type.includes('HOLIDAY_PLUS') &&
                            !block.type.includes('ZOHO')
                        "
                        class="chatbot-btn"
                        @click="showBlockInfo = true"
                    >
                        <md-icon style="color: dodgerblue">info</md-icon>
                    </button>
                    <div v-if="showBlockInfo" class="custom-modal-overlay" @click.self="showBlockInfo = false">
                        <div class="custom-modal">
                            <div class="custom-modal-header">
                                <h3 style="font-weight: 700">{{ $t(`chatbotv2.${block.type}`) }}</h3>
                                <button class="close-btn" @click="showBlockInfo = false">
                                    <md-icon>close</md-icon>
                                </button>
                            </div>
                            <div class="custom-modal-content">
                                <div class="platform-info">
                                    <p style="font-size: 1.2rem; color: initial">
                                        {{ $t(`chatbotv2.${block.type}Desc`) }}
                                    </p>
                                </div>
                            </div>
                            <div class="custom-modal-footer">
                                <SupsisButton ghost @click="openDocumentation" class="documentation-link">
                                    <i class="material-icons" style="padding: 0px 0px 0px 5px">open_in_new</i>
                                    <span style="padding: 0px 15px 0px 5px">{{ $t("billing.more") }}</span>
                                </SupsisButton>
                                <SupsisButton primary @click="showBlockInfo = false">
                                    <span style="padding: 0px 10px">{{ $t("message.close") }}</span>
                                </SupsisButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body">
                <span class="bg-primary text-light p-3 w-100 d-block" v-if="previewMode">
                    {{ $t("chatbotv2.previewModeCaution") }}
                </span>

                <div class="payload-wrapper" v-if="!payload">
                    {{ $t("chatbotv2.addPayload") }}
                </div>
                <div v-else class="payload-wrapper">
                    <template v-if="block.type === BLOCK_TYPES.BOT_RESPONSE">
                        <BotResponse v-model="payload" :preview-mode="previewMode" :flattedDiagram="flattedDiagram" />
                    </template>
                    <template v-if="block.type === BLOCK_TYPES.AI_BOT_RESPONSE">
                        <AIBotResponse v-model="payload" :preview-mode="previewMode" :flattedDiagram="flattedDiagram" />
                    </template>
                    <template v-if="block.type === BLOCK_TYPES.AI_CLASSIFICATION">
                        <AIClassification
                            v-model="payload"
                            :preview-mode="previewMode"
                            :flattedDiagram="flattedDiagram"
                        />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.USER_INPUT">
                        <UserInput v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.ATTACHMENT_INPUT">
                        <AttachmentInput v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.GO_TO_STEP">
                        <GotoStep
                            v-model="payload"
                            :flatted-diagram="flattedDiagram"
                            :isGotoStep="block.type === BLOCK_TYPES.GO_TO_STEP"
                        />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.ADD_TO_SEGMENT">
                        <AddToSegment v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.REMOVE_FROM_SEGMENT">
                        <RemoveFromSegment v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TRANSFER_TO_CHATBOT">
                        <ForwardToChatbot v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SET_ATTRIBUTE">
                        <SetAttribute v-model="payload" :payloads="Payloads" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SET_DEPARTMENT">
                        <SetDepartment v-model="payload" :payloads="Payloads" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.QUESTION">
                        <Question v-model="payload" :payloads="Payloads" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.FILTER">
                        <FilterBlockEditor v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_ORDER_STATUS">
                        <AkinonOrderStatus v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_SELECT_ORDER">
                        <AkinonSelectOrder v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_SELECT_SIZE">
                        <AkinonSelectSize v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK">
                        <AkinonFindNearestStock v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_FIND_NEAREST_STORES">
                        <AkinonFindNearestStores v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_FIND_PRODUCT">
                        <AkinonFindProduct v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.AKINON_SHOW_DISCOUNT_CODES">
                        <AkinonShowDiscountCodes v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SEND_TRANSCRIPT">
                        <SendTranscript v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SEND_SMS">
                        <SendSMS v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SEND_MAIL">
                        <SendMail v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.CREATE_EVENT">
                        <CreateEvent v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.CREATE_RESERVATION">
                        <CreateReservation v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.RESERVATION_OPEN_URL">
                        <ReservationOpenUrl v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.RESERVATION_SELECT_DAY">
                        <ReservationSelectDay v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.RESERVATION_SELECT_TIME">
                        <ReservationSelectTime v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.RESERVATION_EVENT_LIST">
                        <ReservationEventList v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.CREATE_TICKET">
                        <CreateTicket v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TAG_CHAT">
                        <AddTag v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.REMOVE_TAG">
                        <RemoveTag v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.WEBHOOK">
                        <WebHook v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.GET_LOCATION">
                        <GetLocation v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_SELECT_BRANCH">
                        <ProbelSelectBranch v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_SELECT_CLINIC">
                        <ProbelSelectPolyClinic v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_SELECT_DAY">
                        <ProbelSelectDay v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_SELECT_HOUR">
                        <ProbelSelectHour v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT">
                        <ProbelMakeAppointment v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT">
                        <ProbelCancelAppointment v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN">
                        <ProbelGetPatientToken v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_FILL_INFO">
                        <ProbelFillInfo v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT">
                        <ProbelSelectAppointment v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.CREATE_TASK">
                        <CreateTask v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.IDEASOFT_SELECT_ORDER">
                        <IdeasoftSelectOrder v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.IDEASOFT_ORDER_STATUS">
                        <IdeasoftOrderStatus v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.IDEASOFT_GET_MEMBER_INFO">
                        <IdeasoftGetMemberInfo v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.IDEASOFT_PRODUCT_SEARCH">
                        <IdeasoftProductSearch v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SUPPRESSION_ADD">
                        <SuppressionAdd v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SUPPRESSION_REMOVE">
                        <SuppressionRemove v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.B2CARGO_LOGIN_USER">
                        <B2CargoLoginUser v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.B2CARGO_PRODUCT_STATUS">
                        <B2CargoProductStatus v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.DEFAULT_TIMEOUT">
                        <TimeoutBlock v-model="payload" :global="true" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TIMEOUT">
                        <TimeoutBlock v-model="payload" :flattedDiagram="flattedDiagram" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE">
                        <WhatsappBusinessMessage v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE">
                        <InstagramCommentReplyAsPrivate v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSTAGRAM_COMMENT_HIDE">
                        <InstagramCommentHide v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSTAGRAM_COMMENT_SHOW">
                        <InstagramCommentShow v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSTAGRAM_COMMENT_DELETE">
                        <InstagramCommentDelete v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSTAGRAM_COMMENT_REPLY">
                        <InstagramCommentReply v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.HOLIDAY_PLUS_GET_HOTELS">
                        <HolidayPlusHotels v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.HOLIDAY_PLUS_GET_ROOMS">
                        <HolidayPlusRooms v-model="payload" />
                    </template>

                    <template v-else-if="block.type === BLOCK_TYPES.TABLE_CREATE_RECORD">
                        <CreateRecord v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TABLE_UPDATE_RECORD">
                        <UpdateRecord v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TABLE_DELETE_RECORD">
                        <DeleteRecord v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TABLE_FIND_RECORD">
                        <FindRecord v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TABLE_FIND_RECORDS">
                        <FindRecords v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.ZOHO_CREATE_RECORD">
                        <ZohoCreateRecord v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.API_REQUEST">
                        <CustomWebhook v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.FEEDBACK_AI_ASSISTANT">
                        <FeedbackAIAssistant v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.ASSIGN_OWNER">
                        <AssignOwner v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSTAGRAM_SEND_MESSAGE">
                        <InstagramSendMessage v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.MESSENGER_SEND_MESSAGE">
                        <MessengerSendMessage v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TAVILY_WEB_SEARCH">
                        <TavilyWebSearch v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.OPENAI_WEB_SEARCH">
                        <OpenaiWebSearch v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TSOFT_ORDER_STATUS">
                        <TsoftOrderStatus v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TSOFT_SELECT_ORDER">
                        <TsoftSelectOrder v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TICIMAX_V2_ORDER_STATUS">
                        <TicimaxV2OrderStatus v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.TICIMAX_V2_SELECT_ORDER">
                        <TicimaxV2SelectOrder v-model="payload" />
                    </template>
                    <template v-if="block.type === BLOCK_TYPES.AI_CALL">
                        <AICall v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-if="block.type === BLOCK_TYPES.IKAS_GET_MEMBER_INFO">
                        <IkasGetMemberInfo v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.IKAS_SELECT_ORDER">
                        <IkasSelectOrder v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.IKAS_ORDER_STATUS">
                        <IkasOrderStatus v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.INSERT_TO_SYSTEM_PROMPT">
                        <InsertToSystemPrompt v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.META_SEND_CAPI_EVENT">
                        <MetaSendCapiEvent v-model="payload" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.RUN_JAVASCRIPT">
                        <RunJavaScript v-model="payload" :block-id="block.id" />
                    </template>
                    <template v-else-if="block.type === BLOCK_TYPES.CUSTOM_BLOCK">
                        <CustomBlockConfig v-model="payload" :block-id="block.id" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import _ from "lodash";
import log2 from "../../../../../../../utils/log2";
import BotResponse from "../../blocks/BotResponse";
import UserInput from "../../blocks/UserInput";
import GotoStep from "../../blocks/GotoStep";
import SetAttribute from "../../blocks/SetAttribute";
import Question from "../../blocks/Question";
import FilterBlockEditor from "../../blocks/FilterBlockEditor";
import BlockIconPreview from "../../common/BlockIconPreview";
import { ActionPalette } from "../../../../chatbot";
import BlockTitle from "../BlockTitle";
import BLOCK_TYPES from "../../../../block.types";
import AttachmentInput from "../../blocks/AttachmentInput";
import SendTranscript from "../../blocks/SendTranscript";
import SendSMS from "../../blocks/SendSMS";
import SendMail from "../../blocks/SendMail";
import CreateEvent from "../../blocks/CreateEvent";
import HolidayPlusHotels from "../../blocks/HolidayPlusHotels";
import ReservationOpenUrl from "../../blocks/ReservationOpenUrl.vue";
import CreateTicket from "../../blocks/CreateTicket";
import AddToSegment from "../../blocks/AddToSegment";
import RemoveFromSegment from "../../blocks/RemoveFromSegment";
import AddTag from "../../blocks/AddTag";
import RemoveTag from "../../blocks/RemoveTag";
import WebHook from "../../blocks/WebHook";
import AkinonOrderStatus from "../../blocks/akinon/AkinonOrderStatus";
import AkinonSelectOrder from "../../blocks/akinon/AkinonSelectOrder";
import AkinonFindNearestStock from "../../blocks/akinon/AkinonFindNearestStock";
import GetLocation from "../../blocks/get-location/GetLocation";
import AkinonSelectSize from "../../blocks/akinon/AkinonSelectSize";
import AkinonFindProduct from "../../blocks/akinon/AkinonFindProduct";
import AkinonShowDiscountCodes from "../../blocks/akinon/AkinonShowDiscountCodes";
import AkinonFindNearestStores from "../../blocks/akinon/AkinonFindNearestStores";
import SetDepartment from "../../blocks/SetDepartment";
import AIBotResponse from "../../blocks/AIBotResponse";
import AIClassification from "../../blocks/AIClassification";
import ProbelSelectBranch from "../../blocks/probel/ProbelSelectBranch";
import ReservationSelectDay from "../../blocks/reservation/ReservationSelectDay";
import ReservationSelectTime from "../../blocks/reservation/ReservationSelectTime";
import ReservationEventList from "../../blocks/reservation/ReservationEventList";
import ProbelSelectPolyClinic from "../../blocks/probel/ProbelSelectPolyClinic";
import ProbelSelectDay from "../../blocks/probel/ProbelSelectDay";
import ProbelSelectHour from "../../blocks/probel/ProbelSelectHour";
import ProbelMakeAppointment from "../../blocks/probel/ProbelMakeAppointment";
import ProbelCancelAppointment from "../../blocks/probel/ProbelCancelAppointment";
import ProbelGetPatientToken from "../../blocks/probel/ProbelGetPatientToken";
import ProbelFillInfo from "../../blocks/probel/ProbelFillInfo";
import ProbelSelectAppointment from "../../blocks/probel/ProbelSelectAppointment";
import CreateTask from "../../blocks/CreateTask.vue";
import StringUtils from "../../../../../../../utils/StringUtils";
import IdeasoftSelectOrder from "../../blocks/ideasoft/IdeasoftSelectOrder.vue";
import IdeasoftOrderStatus from "../../blocks/ideasoft/IdeasoftOrderStatus.vue";
import IdeasoftGetMemberInfo from "../../blocks/ideasoft/IdeasoftGetMemberInfo.vue";
import IdeasoftProductSearch from "../../blocks/ideasoft/IdeasoftProductSearch.vue";
import SuppressionAdd from "../../blocks/SuppressionAdd.vue";
import SuppressionRemove from "../../blocks/SuppressionRemove.vue";
import B2CargoLoginUser from "../../blocks/b2cargo/B2CargoLoginUser.vue";
import B2CargoProductStatus from "../../blocks/b2cargo/B2CargoProductStatus.vue";
import TimeoutBlock from "../../blocks/TimeoutBlock.vue";
import WhatsappBusinessMessage from "../../blocks/WhatsappBusinessMessage.vue";
import InstagramCommentReply from "../../blocks/InstagramCommentReply.vue";
import InstagramCommentDelete from "../../blocks/InstagramCommentDelete.vue";
import InstagramCommentShow from "../../blocks/InstagramCommentShow.vue";
import InstagramCommentHide from "../../blocks/InstagramCommentHide.vue";
import InstagramCommentReplyAsPrivate from "../../blocks/InstagramCommentReplyAsPrivate.vue";
import ForwardToChatbot from "../../blocks/ForwardToChatbot.vue";
import CreateReservation from "../../blocks/CreateReservation.vue";
import HolidayPlusRooms from "../../blocks/HolidayPlusRooms.vue";
import CreateRecord from "../../blocks/table/CreateRecord.vue";
import UpdateRecord from "../../blocks/table/UpdateRecord.vue";
import DeleteRecord from "../../blocks/table/DeleteRecord.vue";
import FindRecord from "../../blocks/table/FindRecord.vue";
import FindRecords from "../../blocks/table/FindRecords.vue";
import ZohoCreateRecord from "../../blocks/zoho/ZohoCreateRecord.vue";
import CustomWebhook from "../../blocks/CustomWebhook.vue";
import FeedbackAIAssistant from "../../blocks/FeedbackAIAssistant.vue";
import AssignOwner from "../../blocks/AssignOwner.vue";
import InstagramSendMessage from "../../blocks/InstagramSendMessage.vue";
import MessengerSendMessage from "../../blocks/MessengerSendMessage.vue";
import TavilyWebSearch from "../../blocks/TavilyWebSearch.vue";
import OpenaiWebSearch from "../../blocks/OpenaiWebSearch.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import TsoftOrderStatus from "../../blocks/tsoft/TsoftOrderStatus.vue";
import TsoftSelectOrder from "../../blocks/tsoft/TsoftSelectOrder.vue";
import TicimaxV2OrderStatus from "../../blocks/ticimax/TicimaxV2OrderStatus.vue";
import TicimaxV2SelectOrder from "../../blocks/ticimax/TicimaxV2SelectOrder.vue";
import IkasGetMemberInfo from "../../blocks/ikas/IkasGetMemberInfo.vue";
import AICall from "../../blocks/AICall.vue";
import IkasSelectOrder from "../../blocks/ikas/IkasSelectOrder.vue";
import IkasOrderStatus from "../../blocks/ikas/IkasOrderStatus.vue";
import InsertToSystemPrompt from "../../blocks/InsertToSystemPrompt.vue";
import MetaSendCapiEvent from "../../blocks/MetaSendCapiEvent.vue";
import RunJavaScript from "../../blocks/RunJavaScript.vue";
import CustomBlockConfig from "../../blocks/CustomBlockConfig.vue";

const { Payloads } = require("../../../../chatbot");

const log = log2("BlockModal");
export default {
    name: "BlockModal",
    components: {
        AICall,
        MessengerSendMessage,
        InstagramSendMessage,
        CreateRecord,
        UpdateRecord,
        DeleteRecord,
        FindRecord,
        FindRecords,
        HolidayPlusRooms,
        CreateReservation,
        InstagramCommentReplyAsPrivate,
        InstagramCommentHide,
        InstagramCommentShow,
        InstagramCommentDelete,
        InstagramCommentReply,
        TimeoutBlock,
        WhatsappBusinessMessage,
        SuppressionAdd,
        SuppressionRemove,
        IdeasoftGetMemberInfo,
        IdeasoftOrderStatus,
        IdeasoftSelectOrder,
        IdeasoftProductSearch,
        SupsisButton,
        WebHook,
        AddTag,
        RemoveTag,
        RemoveFromSegment,
        AddToSegment,
        FilterBlockEditor,
        Question,
        SetAttribute,
        SetDepartment,
        GotoStep,
        UserInput,
        AttachmentInput,
        BotResponse,
        AIBotResponse,
        AIClassification,
        BlockIconPreview,
        BlockTitle,
        AkinonOrderStatus,
        AkinonSelectOrder,
        AkinonSelectSize,
        AkinonFindNearestStock,
        AkinonFindNearestStores,
        AkinonFindProduct,
        AkinonShowDiscountCodes,
        SendTranscript,
        CreateTicket,
        GetLocation,
        ProbelSelectBranch,
        ProbelSelectPolyClinic,
        ProbelSelectDay,
        ProbelSelectHour,
        ProbelMakeAppointment,
        ProbelCancelAppointment,
        ProbelGetPatientToken,
        ProbelFillInfo,
        ProbelSelectAppointment,
        SendSMS,
        SendMail,
        CreateTask,
        CreateEvent,
        HolidayPlusHotels,
        B2CargoLoginUser,
        B2CargoProductStatus,
        ReservationSelectDay,
        ReservationSelectTime,
        ReservationOpenUrl,
        ReservationEventList,
        ForwardToChatbot,
        ZohoCreateRecord,
        CustomWebhook,
        FeedbackAIAssistant,
        AssignOwner,
        TavilyWebSearch,
        OpenaiWebSearch,
        TsoftOrderStatus,
        TsoftSelectOrder,
        IkasGetMemberInfo,
        IkasSelectOrder,
        IkasOrderStatus,
        TicimaxV2OrderStatus,
        TicimaxV2SelectOrder,
        InsertToSystemPrompt,
        MetaSendCapiEvent,
        RunJavaScript,
        CustomBlockConfig,
    },
    props: ["block", "storyId", "storyVersion", "flattedDiagram", "previewMode"],
    data() {
        return {
            Payloads,
            ActionPalette,
            payload: null,
            didChanged: false,
            isSaveProp: false,
            showBlockInfo: false,
            BLOCK_TYPES,
        };
    },
    methods: {
        ...mapActions({
            updateBlock: "CB/updateBlock",
        }),
        openDocumentation() {
            window.open("https://doc.supsis.live/supsis/chatbot/chatbotBlocks", "_blank");
        },
        async updatePayload(fromOutside = false) {
            if (this.previewMode) return;
            if (fromOutside && !this.didChanged) return false;
            try {
                if (fromOutside) {
                    await this.$dialog.confirm(this.$t("chatbotv2.blockChangedWannaUpdate"), {
                        okText: this.$t("message.yes"),
                        cancelText: this.$t("message.no"),
                    });
                }
                this.isSaveProp = true;
                await this.updateBlock({
                    id: this.storyId,
                    version: this.storyVersion,
                    blockId: this.block.id,
                    payload: {
                        payload: this.payload,
                    },
                }).catch(_.noop);
                if (!fromOutside) {
                    this.$toasted.success(this.$t("chatbotv2.blockUpdated"), {
                        duration: 2000,
                        position: "bottom-center",
                    });
                    this.$emit("close");
                }
                return true;
            } catch (e) {
                return false;
            }
        },
    },
    mounted() {
        if (!!this.block.payload) this.payload = _.cloneDeep(this.block.payload);
        else this.payload = _.cloneDeep(Payloads[this.block.type].default);
    },
    watch: {
        payload: {
            deep: true,
            handler(nV, oV) {
                if (!this.didChanged && !StringUtils.isDeepEqual(nV, this.block.payload) && oV !== null) {
                    if (this.previewMode) {
                        this.$message.error("Cannot update  in preview mode");
                        return;
                    }
                    this.didChanged = true;
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.custom-modal {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.custom-modal-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.custom-modal-content {
    padding: 20px;
}

.custom-modal-footer {
    padding: 20px;
    border-top: 1px solid #eee;
    text-align: right;
    display: flex;
    justify-content: space-between;
}
</style>

<style lang="scss">
.close-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #666;
}

.primary-btn {
    background: #1976d2;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
}

.platform-info {
    margin-bottom: 20px;
}

.platform-info h4 {
    margin-bottom: 10px;
    color: #333;
}

.platform-info p {
    color: #666;
    line-height: 1.5;
}

.block-modal {
    position: fixed;
    right: 1rem;
    top: 1rem;
    z-index: 999;
    display: flex;
    align-items: flex-start;

    .ant-select-selection-selected-value {
        .row {
            flex-wrap: nowrap !important;
        }
    }

    .icon-preview-block-modal {
        font-size: 19px;
        padding-top: 1px;
    }

    &[block-type="SEND_WP_BUSINESS_MESSAGE"] {
        .main {
            width: 750px !important;
            max-width: 100% !important;
        }
    }
    
    &[block-type="RUN_JAVASCRIPT"] {
        .main {
            width: 1000px !important;
            max-width: 100% !important;
        }
    }
    
    &[block-type="CUSTOM_BLOCK"] {
        .main {
            width: 800px !important;
            max-width: 100% !important;
        }
    }

    .main {
        max-width: 600px;
        width: 600px;
        overflow-x: hidden;

        .header {
            padding: 1rem 1.5rem 1rem 2rem;
            margin-left: 2rem;
            background: #fff;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;

            .left {
                .type {
                    color: #919ead;
                    font-weight: 600;
                    text-transform: uppercase;
                }

                .name {
                    font-weight: bold;
                    font-size: 1.5rem;
                }

                .custom-block-logo {
                    width: 24px;
                    height: 24px;
                }
            }

            .right {
                position: absolute;
                top: 0.5rem;
                right: 1rem;
                display: flex;
                gap: 0.5rem;

                .chatbot-btn {
                    border: none;
                    background: #dfdfdf;
                    border-radius: 4px;
                    padding: 4px 8px;
                    margin: 0;
                    min-height: 34px;
                    min-width: 34px;
                    color: #000;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &.bordered {
                        border: 1px solid #000;
                    }
                }
            }
        }

        .body {
            padding-left: 2rem;
            max-height: calc(100vh - 140px);
            overflow-y: scroll;

            &::-webkit-scrollbar {
                display: none;
            }

            .payload-wrapper {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                background: #dfdfdf;
                padding: 1rem 0;
            }

            .payload {
                padding: 0 1.5rem;
                position: relative;

                input[type="checkbox"] {
                    display: none;

                    & + input {
                        display: none;
                    }

                    &:checked + input {
                        display: block;
                    }
                }

                textarea {
                    width: 100%;
                    resize: none;
                    height: 100px;
                    border: 1px solid transparent;
                    border-radius: 12px;
                    padding: 6px 12px;

                    &::-webkit-scrollbar {
                        display: none;
                    }

                    &:focus {
                        border-color: #06a9f3;
                    }
                }

                label {
                    display: flex;
                    gap: 1rem;
                    align-items: center;

                    span {
                        background: #888888;
                        padding: 0.4rem 0.7rem;
                        border-radius: 1rem;
                        color: #ffffff;
                        user-select: none;
                        transition: all 0.3s ease-in-out;
                        cursor: pointer;
                        min-width: 100px;
                        text-align: center;

                        &:hover {
                            background: #a2a2a2;
                        }
                    }

                    .attr-val {
                        width: 100%;
                        resize: none;
                        border: 1px solid #a2a2a2;
                        border-radius: 2px;
                        padding: 0.3rem 0.9rem;

                        &:focus {
                            border: 1px solid #0651f3;
                        }
                    }
                }

                .toolbar {
                    opacity: 0;
                    transition: all 0.3s ease-in-out;
                    position: absolute;
                    left: -17px;
                    bottom: 0;
                    top: 28px;
                    display: flex;
                    flex-direction: column;
                    //justify-content: center;
                    gap: 0.6rem;

                    .toolbar-btn {
                        border: none;
                        background: #ffffff;
                        border-radius: 50%;
                        margin: 0;
                        //height: 34px;
                        //width: 34px;
                        min-height: 30px;
                        min-width: 30px;
                        color: #000;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-shadow: 0 4px 20px #00000040;

                        &.bordered {
                            border: 1px solid #000;
                        }
                    }
                }

                &:hover .toolbar {
                    opacity: 1;
                }

                .chatbot-btn {
                    border: none;
                    background: #bd5555;
                    border-radius: 4px;
                    padding: 4px 8px;
                    margin: 0;
                    min-height: 34px;
                    min-width: 34px;
                    color: #000;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    right: 10px;
                    top: 60px;

                    i {
                        color: #ffffff;
                    }

                    &.bordered {
                        border: 1px solid #000;
                    }
                }

                .keywords {
                    display: flex;
                    flex-wrap: wrap;
                    max-width: 430px;
                    gap: 0.4rem;
                    margin: 1rem 0;

                    .keyword {
                        border: 1px dashed #aaa;
                        border-radius: 1.5rem;
                        padding: 0.5rem 1rem;
                        background: transparent;
                        text-align: center;
                        transition: all 0.3s ease-in-out;
                        font-weight: bold;
                        max-width: 80px;

                        &::placeholder {
                            color: #000;
                        }

                        &:focus {
                            border: 1px solid;
                        }

                        &.filled:not(:focus) {
                            border: 1px solid #0651f3;
                            background-color: #0651f3;
                            color: #ffffff;
                        }
                    }
                }

                .says {
                    display: flex;
                    flex-direction: column;
                    gap: 0.4rem;
                    margin: 1rem 0;

                    .say {
                        width: 100%;
                        resize: none;
                        border: 1px solid transparent;
                        border-radius: 12px;
                        padding: 14px;

                        &:focus {
                            border: 1px solid #0651f3;
                        }
                    }
                }
            }

            .cbcard {
                background-color: #ffffff;
                border-radius: 4px;
                margin: 0 1.5rem;
                padding: 1rem;
            }

            .cbcard-btn {
                border: none;
                background: #fff;
                align-self: center;
                border-radius: 50%;
                height: 36px;
                transform: scale(0.7);

                &::before {
                    content: "";
                    width: 2px;
                    height: 1.9rem;
                    display: block;
                    z-index: -3;
                    position: absolute;
                    bottom: 100%;
                    left: 50%;
                    transform: translateX(-50%);
                    border: 1px dashed #888888;
                }
            }

            .condition-card {
                display: flex;
                margin-bottom: 1rem;
            }

            .cbcondition-btn {
                width: 100%;
                padding: 8px 15px;
                border-radius: 4px;
                border: 1px solid #dadada;
                transition: all 0.3s ease-in-out;
                background-color: #ffffff;

                &:hover {
                    border: 1px solid #06a9f3;
                    color: #06a9f3;
                }
            }
        }
    }

    .ant-divider-horizontal.ant-divider-with-text-center::before,
    .ant-divider-horizontal.ant-divider-with-text-center::after {
        border-top: 1px solid #a8a8a8;
    }
}
</style>
